
import React from 'react';
import { Compass, Users, Scan, MessageSquare, User, Menu } from 'lucide-react';
import { GoogleUser } from '../types';

interface Props {
  activeTab: string;
  onTabChange: (tab: any) => void;
  onScan: () => void;
  onProfileClick: () => void;
  unreadCount: number;
  user: GoogleUser | null;
}

const BottomNav: React.FC<Props> = ({ activeTab, onTabChange, onScan, onProfileClick, unreadCount, user }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] md:hidden">
      {/* Blur Backdrop */}
      <div className="absolute inset-0 bg-slate-950/90 backdrop-blur-xl border-t border-slate-800"></div>
      
      <div className="relative flex justify-around items-center h-[80px] pb-4 px-2">
        
        {/* 1. Explore */}
        <button 
          onClick={() => onTabChange('explore')}
          className={`flex flex-col items-center justify-center w-14 gap-1 transition-colors ${activeTab === 'explore' ? 'text-blue-400' : 'text-slate-500 hover:text-slate-300'}`}
        >
          <Compass className={`w-6 h-6 ${activeTab === 'explore' ? 'fill-blue-500/20' : ''}`} />
          <span className="text-[9px] font-black uppercase tracking-wider">Search</span>
        </button>

        {/* 2. Network */}
        <button 
          onClick={() => onTabChange('social')}
          className={`flex flex-col items-center justify-center w-14 gap-1 transition-colors ${activeTab === 'social' ? 'text-purple-400' : 'text-slate-500 hover:text-slate-300'}`}
        >
          <Users className={`w-6 h-6 ${activeTab === 'social' ? 'fill-purple-500/20' : ''}`} />
          <span className="text-[9px] font-black uppercase tracking-wider">Social</span>
        </button>

        {/* 3. SCAN (Center Floating) */}
        <div className="relative -top-6">
          <button 
            onClick={onScan}
            className="w-16 h-16 rounded-full bg-gradient-to-tr from-blue-600 to-cyan-500 flex items-center justify-center shadow-[0_0_20px_rgba(37,99,235,0.5)] border-4 border-slate-950 active:scale-95 transition-transform"
          >
            <Scan className="w-8 h-8 text-white" />
          </button>
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-full text-center">
            <span className="text-[9px] font-black text-blue-400 uppercase tracking-widest shadow-black drop-shadow-md">SCAN</span>
          </div>
        </div>

        {/* 4. Messages */}
        <button 
          onClick={() => onTabChange('messages')}
          className={`relative flex flex-col items-center justify-center w-14 gap-1 transition-colors ${activeTab === 'messages' ? 'text-green-400' : 'text-slate-500 hover:text-slate-300'}`}
        >
          <div className="relative">
            <MessageSquare className={`w-6 h-6 ${activeTab === 'messages' ? 'fill-green-500/20' : ''}`} />
            {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 h-3.5 w-3.5 bg-red-500 rounded-full border-2 border-slate-950 flex items-center justify-center text-[8px] font-bold text-white">
                    {unreadCount}
                </span>
            )}
          </div>
          <span className="text-[9px] font-black uppercase tracking-wider">Comms</span>
        </button>

        {/* 5. Profile / Menu */}
        <button 
          onClick={onProfileClick}
          className={`flex flex-col items-center justify-center w-14 gap-1 transition-colors ${activeTab === 'profile' ? 'text-white' : 'text-slate-500 hover:text-slate-300'}`}
        >
          {user ? (
              <div className="relative">
                  <img 
                    src={user.avatar} 
                    alt="Profile" 
                    className={`w-7 h-7 rounded-full border-2 object-cover transition-all ${activeTab === 'profile' ? 'border-white shadow-[0_0_10px_rgba(255,255,255,0.3)] scale-110' : 'border-slate-600'}`}
                  />
                  {/* Online dot indicator logic could go here if needed */}
              </div>
          ) : (
              <User className="w-6 h-6" />
          )}
          <span className="text-[9px] font-black uppercase tracking-wider">Profile</span>
        </button>

      </div>
    </div>
  );
};

export default BottomNav;
